import { MagnitudesModel } from '@/store/catalogos/magnitudes';
import { Util } from '@/utils/util';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CatalogoMagnitudesService } from '@services/catalogo/catalogoMagnitudes.service';
import { ValidatorsService } from '@services/util/validators.service';

@Component({
  selector: 'app-formulario-magnitudes',
  templateUrl: './formulario-magnitudes.component.html',
  styleUrls: ['./formulario-magnitudes.component.scss']
})
export class FormularioMagnitudesComponent {
  form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Nueva Magnitud";


  constructor(
    private util: Util,
    private catalogoService: CatalogoMagnitudesService,
    public dialogRef: MatDialogRef<FormularioMagnitudesComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.update) {
      this.title = "Modificar Magnitud";
    }
    if (data.view) {
      this.title = "Vista Magnitud";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);

  }

  private buildForm(data: MagnitudesModel): void {
    this.form = new FormGroup({
      idVariable: new FormControl(data?.idVariable ?? null),
      nombreVariable: new FormControl(data?.nombreVariable ?? '', {
        validators: [Validators.required, Validators.maxLength(50)]
      })
    });

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
    }
  }

 
  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }


  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const magnitud: MagnitudesModel = this.formToModel();
    const request = this.data.insert

      ? this.catalogoService.create(magnitud)
      : this.catalogoService.update(magnitud);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }


  private formToModel(): MagnitudesModel {
    const formValues = this.form.getRawValue();

    return {
      idVariable: formValues.idVariable ?? '',
      nombreVariable: formValues.nombreVariable ?? ''
    };
  }
}
